import { DEVICE_TYPE } from '../resources/const'
import { removeNullishProperty } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'

export const convertAmountToNumber = (amount) => {
  const result = parseInt(`${amount}`.replace(/,/g, ''))
  return isNaN(result) ? undefined : result
}
export const getPurchaseProperties = (origin) => {
  const result = removeNullishProperty({
    product_id: origin.productId,
    price: convertAmountToNumber(origin.price),
    currency: 'KRW',
    device_type: DEVICE_TYPE.get('pc'),
  })
  // TODO: 페이레터에서 실어주는 실결제가 파라미터 key값으로 세팅
  if (origin.amount) {
    result.pg_amount = convertAmountToNumber(origin.amount)
  }
  return result
}

export const getContentViewProperties = (origin = {}) => {
  return removeNullishProperty({
    program_id: origin.program_id,
    content_id: origin.content_id,
    content_number: origin.content_number,
    title: origin.title,
    section: origin.section,
    sub_genre_tag: origin.sub_genre_tag,
    country: origin.country,
  })
}

export const normalizePurchaseParams = (origin) => {
  const { productid: productId, amount } = origin

  return {
    productId,
    // 결제 완료시 payletter에서 실제 이용권 금액정보가 amount라는 파라미터로 넘어오기 때문에 price로 이름 변경
    price: convertAmountToNumber(amount),
  }
}

export const getUserExternalId = () => {
  const uno = cookie.getUno()
  const profileId = cookie.getProfileId()
  if (uno === 'none' && profileId === 'none') {
    return 'none'
  }
  return `${uno}_${profileId}`
}
